import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ 
  title, 
  description, 
  iconName, 
  iconColor, 
  actionLabel, 
  actionPath, 
  isEmergency = false,
  badge = null 
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    navigate(actionPath);
  };

  return (
    <div className={`clinical-card p-6 transition-clinical hover:shadow-md ${
      isEmergency ? 'border-l-4 border-l-error' : ''
    }`}>
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
          isEmergency ? 'bg-error/10' : 'bg-primary/10'
        }`}>
          <Icon name={iconName} size={24} color={iconColor} />
        </div>
        {badge && (
          <span className="status-badge status-badge-warning">
            {badge}
          </span>
        )}
      </div>
      
      <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-4">{description}</p>
      
      <Button 
        variant={isEmergency ? 'destructive' : 'default'}
        fullWidth
        iconName="ArrowRight"
        iconPosition="right"
        onClick={handleAction}
      >
        {actionLabel}
      </Button>
    </div>
  );
};

export default QuickActionCard;